import { useMedia } from "hooks";
import {
  BasketKPLabels,
  TBasketData,
  TBasketOptionalExtras,
} from "../BasketKP.types";
import { useCallback, useEffect, useState } from "react";
import * as R from "ramda";

function OptionalExtraCount({
  extra,
  extraIndex,
  renderPrice,
  groupIndex,
  basketData,
  updateBasketProduct,
  performanceGroupIndex,
  basketItemIndex,
  labels,
}: {
  labels: BasketKPLabels;
  performanceGroupIndex: number;
  basketItemIndex: number;
  extraIndex: number;
  extra: TBasketOptionalExtras;
  renderPrice: (price: number | undefined) => string;
  groupIndex: number;
  basketData: TBasketData;
  updateBasketProduct: (dataToUpdate: TBasketData) => void;
}) {
  const { isTablet } = useMedia();
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    console.log(extra.Items[0].BasketQuantity);
    setCount(extra.Items[0].BasketQuantity);
  }, [extra]);

  const onAddToBasketClick = useCallback(() => {
    updateBasketProduct(
      R.modifyPath(
        [
          "PerformanceGroups",
          performanceGroupIndex,
          "BasketPackagesAndExtras",
          basketItemIndex,
          "OptionalExtrasGroups",
          groupIndex,
          "OptionalExtras",
          extraIndex,
          "Items",
          0,
          "BasketQuantity",
        ],
        () => count,
        basketData
      )
    );
  }, [
    basketData,
    basketItemIndex,
    count,
    extraIndex,
    groupIndex,
    performanceGroupIndex,
    updateBasketProduct,
  ]);

  return (
    <div
      key={extra.ProductId}
      style={{
        display: isTablet ? "block" : "grid",
        gridTemplateColumns: "150px auto",
        border: "1px solid #D7D7D7",
        padding: isTablet ? "8px" : 0,
        background: isTablet ? "#F1F1F1" : "unset",
      }}
    >
      {isTablet ? (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "80px auto",
              gap: "12px",
            }}
          >
            <div>
              <img
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                }}
                src={extra.LargeImageUrl || labels.OptionalExtrasDefaultImage}
                alt={extra.ProductName}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <h5 style={{ margin: "0", fontSize: "16px" }}>
                {extra.ProductName}
              </h5>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{"+" + renderPrice(extra.Items[0].PriceWithVat)}</span>
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: "16px",
              background: "#F1F1F1",
              display: "flex",
              flexDirection: "row",
              gap: "12px",
            }}
          >
            <div className="o-basket__package__quantity-input">
              <button
                style={{ transform: "scale(0.65)" }}
                onClick={() => count !== 0 && setCount(count - 1)}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    fill={count === 0 ? "transparent" : "#4FE8B5"}
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    stroke={count === 0 ? "#D7D7D7" : "#4FE8B5"}
                  />
                  <path
                    d="M22.1758 20.3242H14V19.1758H22.1758V20.3242Z"
                    fill={count === 0 ? "#D7D7D7" : "#242425"}
                  />
                </svg>
              </button>
              <div
                style={{
                  width: "44px",
                  height: "40px",
                  background: "#ffffff",
                }}
              >
                {count}
              </div>
              <button
                style={{ transform: "scale(0.65)" }}
                onClick={() => setCount(count + 1)}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    fill="#4FE8B5"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    stroke="#4FE8B5"
                  />
                  <path
                    d="M24.9639 20.3223H20.7139V24.5723H19.2861V20.3223H15.0361V18.9277H19.2861V14.6777H20.7139V18.9277H24.9639V20.3223Z"
                    fill="#242425"
                  />
                </svg>
              </button>
            </div>
            <button
              className={`a-button ${
                count === extra.Items[0].BasketQuantity
              } ? 'disabled' : ''}`}
              disabled={count === extra.Items[0].BasketQuantity}
              onClick={onAddToBasketClick}
            >
              {labels.AddToBasket ?? "Add to basket"}
            </button>
          </div>
        </>
      ) : (
        <>
          <div>
            <img
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
              src={extra.LargeImageUrl || labels.OptionalExtrasDefaultImage}
              alt={extra.ProductName}
            />
          </div>
          <div
            style={{
              background: "#F1F1F1",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <h5 style={{ margin: "0", fontSize: "18px" }}>
              {extra.ProductName}
            </h5>

            <div className="o-basket__package__quantity-input">
              <button
                style={{ transform: "scale(0.65)" }}
                onClick={() => count !== 0 && setCount(count - 1)}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    fill={count === 0 ? "transparent" : "#4FE8B5"}
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    stroke={count === 0 ? "#D7D7D7" : "#4FE8B5"}
                  />
                  <path
                    d="M22.1758 20.3242H14V19.1758H22.1758V20.3242Z"
                    fill={count === 0 ? "#D7D7D7" : "#242425"}
                  />
                </svg>
              </button>
              <div
                style={{
                  width: "44px",
                  height: "40px",
                  background: "#ffffff",
                }}
              >
                {count}
              </div>
              <button
                style={{ transform: "scale(0.65)" }}
                onClick={() => setCount(count + 1)}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    fill="#4FE8B5"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    stroke="#4FE8B5"
                  />
                  <path
                    d="M24.9639 20.3223H20.7139V24.5723H19.2861V20.3223H15.0361V18.9277H19.2861V14.6777H20.7139V18.9277H24.9639V20.3223Z"
                    fill="#242425"
                  />
                </svg>
              </button>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>{"+" + renderPrice(extra.Items[0].PriceWithVat)}</span>
              <button
                className={`a-button ${
                  count === extra.Items[0].BasketQuantity
                } ? 'disabled' : ''}`}
                disabled={count === extra.Items[0].BasketQuantity}
                onClick={onAddToBasketClick}
              >
                {labels.AddToBasketText}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default OptionalExtraCount;
